import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './Cart';

const CartSuspense = dynamic(() => import('./Cart'), {
	loading: () => <BlockLoadingSpinner />,
});

export default function DynamicCart(props: Props) {
	return <CartSuspense {...props} />;
}
DynamicCart.displayName = 'DynamicCart';
